import { render, staticRenderFns } from "./ProductsCategoriesFilter.vue?vue&type=template&id=23bdf225&"
import script from "./ProductsCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsCategoriesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports